import React from 'react';
import './contactUs.css';

function ContactUs() {
  return (
    <div className='mainCarousel'>
        This is the contact us page
    </div>
  );
}

export default ContactUs;